// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jXrnE","top":"styles_top__3T3pB","left":"styles_left__1MsaE","description":"styles_description__2yeTD"};